/***
 * File name: incidentsOccured.js
 *
 * Program Description:
 * This file contains all the meta configuration of the How Security Incidents
 * Occurred tab in Annual Security Incident Report module
 *
 * This file defines all the input fields needed for the How Security Incidents
 * Occurred tab
 *
 * Includes the ff:
 * - Tab number indicator
 * - Label of the collection
 * - optionQuery and optionName indicates the query params and collection name
 * for fetching additional data from the server
 * - children includes all the input fields in the form
 * - formActions indicate all the action buttons to be included on top of the form
 * - Other configurations for the form
 * - formKeys inidcate the list of keys/fields to be considered in the How Security
 * Incidents Occurred tab
 *
 */
export default function (vm) {
  return {
    tab: 2,
    label: 'ASIR',
    optionQuery: {
    },
    optionName: [],
    children: [
      {
        is: 'v-row',
        children: [{ is: 'v-col' }]
      },
      // header
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'd-flex'
            },
            children: [
              {
                is: 'h2',
                header: true,
                vText: 'How Security Incidents Occurred',
                vBind: {
                  style: 'color: #162b54'
                }
              },
              {
                is: 'span',
                header: true,
                vText: 'Please do not input negative values.*',
                vBind: {
                  class: 'ml-3'
                }
              }
            ]
          }
        ]
      },
      // 1st row
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'theft',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  label: 'Theft',
                  dense: true,
                  id: 'theft',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  solo: vm.operation === 'view',
                  flat: vm.operation === 'view',
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('theft'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to the illegal transfer or storage of any personal data to unauthorized actors',
                vOn: {
                  input: () => { vm.$v.formItem.theft.$touch() },
                  blur: () => { vm.$v.formItem.theft.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Theft',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'theft',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'theft',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'identityFraud',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  label: 'Identity Fraud',
                  dense: true,
                  id: 'identityFraud',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('identityFraud'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to a successful attempt of using someone\'s identity',
                vOn: {
                  input: () => { vm.$v.formItem.identityFraud.$touch() },
                  blur: () => { vm.$v.formItem.identityFraud.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Identity Fraud',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'identityFraud',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'identityFraud',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'sabotage',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  label: 'Sabotage / Physical Damage',
                  dense: true,
                  id: 'sabotage',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('sabotage'),
                  oninput: 'validity.valid||(value="")'
                },
                info: 'Incidents or events that resulted to an internal or external deliberate act of destruction or disruption of the organization\'s personal data processing activities',
                vOn: {
                  input: () => { vm.$v.formItem.sabotage.$touch() },
                  blur: () => { vm.$v.formItem.sabotage.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Sabotage / Physical Damage',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'sabotage',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'sabotage',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          }
        ]
      },
      // 2nd row
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'maliciousCode',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  label: 'Malicious Code',
                  dense: true,
                  id: 'maliciousCode',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('maliciousCode'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to a malicious code causing damage to personal data processing system',
                vOn: {
                  input: () => { vm.$v.formItem.maliciousCode.$touch() },
                  blur: () => { vm.$v.formItem.maliciousCode.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Malicious Code',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'maliciousCode',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'maliciousCode',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'hacking',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Hacking',
                  dense: true,
                  id: 'hacking',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('hacking'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to intentionally accessing a computer system or personal data processing system without the authorization of the user or the owner',
                vOn: {
                  input: () => { vm.$v.formItem.hacking.$touch() },
                  blur: () => { vm.$v.formItem.hacking.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Hacking',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'hacking',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'hacking',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'misuseOfResources',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Misuse of Resources',
                  dense: true,
                  id: 'misuseOfResources',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('misuseOfResources'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to the deviation from the intended use of any element of a personal data processing system needed to perform required operations',
                vOn: {
                  input: () => { vm.$v.formItem.misuseOfResources.$touch() },
                  blur: () => { vm.$v.formItem.misuseOfResources.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Misuse of Resources',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'misuseOfResources',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'misuseOfResources',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          }
        ]
      },
      // 3rd row
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'hardwareFailure',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Hardware Failure',
                  dense: true,
                  id: 'hardwareFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('hardwareFailure'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to the termination of the ability of all or part of the physical components of a personal processing system to perform a required function',
                vOn: {
                  input: () => { vm.$v.formItem.hardwareFailure.$touch() },
                  blur: () => { vm.$v.formItem.hardwareFailure.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Hardware Failure',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'hardwareFailure',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'hardwareFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'softwareFailure',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Software Failure',
                  dense: true,
                  id: 'softwareFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('softwareFailure'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to the termination of the ability of all or part of the programs, procedures, rules, and associated documentation of a personal data processing system to perform a required function',
                vOn: {
                  input: () => { vm.$v.formItem.softwareFailure.$touch() },
                  blur: () => { vm.$v.formItem.softwareFailure.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Software Failure',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'softwareFailure',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'softwareFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'communicationFailure',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Communication Failure',
                  dense: true,
                  id: 'communicationFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('communicationFailure'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to unexpected release of personal data through any communication means or platforms',
                vOn: {
                  input: () => { vm.$v.formItem.communicationFailure.$touch() },
                  blur: () => { vm.$v.formItem.communicationFailure.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Communication Failure',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'communicationFailure',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'communicationFailure',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          }
        ]
      },
      // 4th row
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'naturalDisaster',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Natural Disaster',
                  dense: true,
                  id: 'naturalDisaster',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('naturalDisaster'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to the abnormal intensity of a natural agent (flood, mudslide, earthquake, avalanche, drought) that caused availability issues',
                vOn: {
                  input: () => { vm.$v.formItem.naturalDisaster.$touch() },
                  blur: () => { vm.$v.formItem.naturalDisaster.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Natural Disaster',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'naturalDisaster',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'naturalDisaster',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'designError',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Design Error',
                  dense: true,
                  id: 'designError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('designError'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to incorrect, incomplete, or poorly communicated design of a system or software to reduce the possibility of user making mistakes.',
                vOn: {
                  input: () => { vm.$v.formItem.designError.$touch() },
                  blur: () => { vm.$v.formItem.designError.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Design Error',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'designError',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'designError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'userError',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'User Error',
                  dense: true,
                  id: 'userError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('userError'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to mistake of human action or inaction that produce an unintended result.',
                vOn: {
                  input: () => { vm.$v.formItem.userError.$touch() },
                  blur: () => { vm.$v.formItem.userError.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'User Error',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'userError',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'userError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          }
        ]
      },
      // 5th row
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'operationsError',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Operations Error',
                  dense: true,
                  id: 'operationsError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('operationsError'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted due to improper execution of the organizations operataional procedures',
                vOn: {
                  input: () => { vm.$v.formItem.operationsError.$touch() },
                  blur: () => { vm.$v.formItem.operationsError.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Operations Error',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'operationsError',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'operationsError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'softwareMaintenanceError',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Software Maintenance Error',
                  dense: true,
                  id: 'softwareMaintenanceError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('softwareMaintenanceError'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that resulted to improper execution of software maintenance such as improving and boosting the software performance and correcting issues or bugs.',
                vOn: {
                  input: () => { vm.$v.formItem.softwareMaintenanceError.$touch() },
                  blur: () => { vm.$v.formItem.softwareMaintenanceError.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Software Maintenance Error',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'softwareMaintenanceError',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'softwareMaintenanceError',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'thirdParty',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Third Party / Service Provider',
                  dense: true,
                  id: 'thirdParty',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('thirdParty'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that exposed personal data of the organization caused by their official third party partners or service providers',
                vOn: {
                  input: () => { vm.$v.formItem.thirdParty.$touch() },
                  blur: () => { vm.$v.formItem.thirdParty.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Third Party / Service Provider',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'thirdParty',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'thirdParty',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vShow: vm.operation !== 'view',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'others',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1 mb-1',
                  label: 'Others',
                  dense: true,
                  id: 'others',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  disabled: vm.isDisabled('others'),
                  oninput: 'validity.valid||(value="")'
                },

                info: 'Incidents or events that do not fall to the criteria mentioned above',
                vOn: {
                  input: () => { vm.$v.formItem.others.$touch() },
                  blur: () => { vm.$v.formItem.others.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view',
            vBind: {
              class: 'pb-0',
              cols: '2'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Others',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'others',
                vBind: {
                  class: 'font-weight-bold text-body-1 required-field',
                  dense: true,
                  id: 'others',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  solo: true,
                  flat: true,
                  type: 'number'
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation !== 'view' &&
            vm.formItem.others > 0,
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'specify',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'Specify',
                  dense: true,
                  id: 'specify',
                  readonly: vm.readOnly
                },
                vOn: {
                  input: () => { vm.$v.formItem.specify.$touch() },
                  blur: () => { vm.$v.formItem.specify.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vShow: vm.operation === 'view' &&
            vm.formItem.others > 0,
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Specify',
                vBind: {
                  class: 'gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'specify',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  id: 'specify',
                  readonly: vm.readOnly
                }
              }
            ]
          }
        ]
      }
    ],
    formActions: [],
    formKeys: [
      'userError',
      'thirdParty',
      'theft',
      'softwareMaintenanceError',
      'softwareFailure',
      'sabotage',
      'others',
      'operationsError',
      'naturalDisaster',
      'misuseOfResources',
      'maliciousCode',
      'identityFraud',
      'hardwareFailure',
      'hacking',
      'designError',
      'communicationFailure'
    ]
  }
}
